webpackJsonp([1],{

/***/ 17:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* 
	 * This script loads orbit sliders on demand. It extends
	 * the orbit slider by generating bullet points automatically 
	 * 
	 * Requires: 
	 *	- foundation.orbit.js / async load
	 *	- foundation.util.timerAndImageLoader.js / async load
	 *	- foundation.util.motion.js / async load
	 *	- foundation.util.touch.js / async load
	 *	
	 *	Extend:
	 *	 - new data Attribute bullet-caption
	 *	  example: 
	 *		<li data-slide="..." data-bullet-caption="..." class="orbit-slide">
	 *		
	 *	Author: Michael Kohler <michael.kohler@somedia.ch>
	 */
	
	// Requires
	var $ = __webpack_require__(1);
	__webpack_require__(11);
	
	// Modul construct
	var somModul = {
	
		// Module name
		name: 'foundation.orbit',
	
		// Container
		container: null,
	
		// Init function
		init: function init() {
	
			// Modify each slider
			somModul.container = $('.orbit');
			somModul.container.each(function () {
	
				// Add bullets if needed
				var $currentOrbit = $(this);
	
				// Ugly - but needed! - Move buttons in ul construct
				var $navButtons = $('.orbit-previous, .orbit-next', $currentOrbit);
				if ($navButtons.length != 0) {
					$currentOrbit.find('.orbit-container').prepend($navButtons);
				}
			});
	
			// Init slider
			somModul.container.foundation();
		}
	};
	
	// Return modul construct - commonJS syntax
	module.exports = somModul;

/***/ }

});


/** WEBPACK FOOTER **
 ** 1.project.js
 **/